import React, { useEffect } from 'react';
import styled from 'styled-components';
import ReactDOM from 'react-dom';

interface ModalProps {
    visible: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2000;
`;

const ModalWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2100;
    background-color: var(--bg-modal);
    border-radius: 20px;
    box-shadow: 0 4px 15px var(--shadow-strong);
    width: 90%;
    max-width: 1024px;

    /* ✨ overflow: hidden인 부모를 탈출해도 내부 스크롤은 가능하게 설정 */
    max-height: 90vh;
    display: flex;
    flex-direction: column;
`;

const Modal: React.FC<ModalProps> = ({ visible, onClose, children }) => {
    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);

        if (visible) {
            document.body.style.overflow = 'hidden';
        }

        return () => window.removeEventListener('keydown', handleEsc);
    }, [onClose, visible]);

    if (!visible) return null;

// ✨ Portal을 사용하여 document.body 바로 아래에 렌더링
    return ReactDOM.createPortal(
        <>
            <Overlay onClick={onClose} />
            <ModalWrapper onClick={(e) => e.stopPropagation()}>
                {children}
            </ModalWrapper>
        </>,
        document.body
    );
};

export default Modal;

